import http from '../../../../config/BaseUrl'
import { liveEventItemList, liveEventLoading } from './liveEventSlice'
export const LiveEventList = (params) => async (dispatch) => {
    try{
        dispatch(liveEventLoading())
        await http.get('live-event', {params}).then((res) => {
           dispatch(liveEventItemList(res.data.event))
        }).catch((err) => {
            console.log(err.response.data.message);
        })
    }catch(error){

    }
}